import type { Dayjs } from 'dayjs';
import { getCurrentCalendarDate } from '@features/regional-overview/utils/current-calendar-date.utils';
import type { DailyCountWindowDay } from '../domain';
import { formatMonthDay } from './localized-date.utils';

interface BuildDailyCountWindowParams {
  anchorDate: Dayjs;
  numberOfDays?: number;
}

export const buildDailyCountWindow = ({ anchorDate, numberOfDays = 7 }: BuildDailyCountWindowParams): DailyCountWindowDay[] => {
  const yesterday = getCurrentCalendarDate().subtract(1, 'day');
  const effectiveAnchorDate = anchorDate.isAfter(yesterday, 'day') ? yesterday : anchorDate;
  const days: DailyCountWindowDay[] = [];

  for (let i = numberOfDays - 1; i >= 0; i--) {
    const date = effectiveAnchorDate.subtract(i, 'day');
    days.push({
      dateKey: date.format('YYYY-MM-DD'),
      label: formatMonthDay(date)
    });
  }

  return days;
};
